import { PhoneIncomingIcon } from './PhoneIncomingIcon';

/**
 * author: Simran
 * id AA8EEDF8-EB34-46C5-8117-9258E1349197
 * name phone-incoming
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/phone-incoming.svg
 * tags
 * - Cellphone / Phone 
 */
export const TelephoneIncomingIcon = PhoneIncomingIcon;
export default TelephoneIncomingIcon